require('vue-swipe/dist/vue-swipe.css');
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/state'
import axios from 'axios'
import config from '@/conf'

axios.defaults.baseURL = `${config.router}`;
axios.interceptors.request.use(function (config) {
  //发送请求前将token带到后端
  if( localStorage.epoqueToken){
    config.headers['X-epoque-mall-Authorization']=JSON.parse(localStorage.epoqueToken).content;
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
  // 响应失败
  if(response.data.error_code&&(response.data.error_code==10001||response.data.error_code==10002)){
    localStorage.removeItem('epoqueToken')  //新加的
    location.reload(true);
  }
  return response;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});
// 全局引入vue-awesome-swiper
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// Vue.use(VueAwesomeSwiper)
// import 'swiper/dist/css/swiper.css'

//全局引入vue-lazyload
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad,{
  preLoad: 1.3,
  error:'./static/img/lazyload_fail.png',
  loading:'./static/img/lazyload.png',
  attempt: 1
})

Vue.config.productionTip = false
// 全局引入vue-swipe
// import { Swipe, SwipeItem } from 'vue-swipe';
// Vue.component('swipe', Swipe);
// Vue.component('swipe-item', SwipeItem);

const vm=new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  methods:{
  },
  created(){
  }
})



// WEBPACK FOOTER //
// ./src/main.js